export const actions = {
  RESTRICCIONES_ENTREGA_LOAD_REQUESTED: 'RESTRICCIONES_ENTREGA_LOAD_REQUESTED',
  RESTRICCIONES_ENTREGA_LOAD_SUCCEEDED: 'RESTRICCIONES_ENTREGA_LOAD_SUCCEEDED',
  RESTRICCIONES_ENTREGA_LOAD_FILED: 'RESTRICCIONES_ENTREGA_LOAD_FILED',

  RESTRICCION_ENTREGA_BYID_LOAD_REQUESTED: 'RESTRICCION_ENTREGA_BYID_LOAD_REQUESTED',
  RESTRICCION_ENTREGA_BYID_LOAD_SUCCEEDED: 'RESTRICCION_ENTREGA_BYID_LOAD_SUCCEEDED',
  RESTRICCION_ENTREGA_BYID_LOAD_FILED: 'RESTRICCION_ENTREGA_BYID_LOAD_FILED',

  RESTRICCION_ENTREGA_INSERT_REQUESTED: 'RESTRICCION_ENTREGA_INSERT_REQUESTED',
  RESTRICCION_ENTREGA_INSERT_SUCCEEDED: 'RESTRICCION_ENTREGA_INSERT_SUCCEEDED',
  RESTRICCION_ENTREGA_INSERT_FILED: 'RESTRICCION_ENTREGA_INSERT_FILED',

  RESTRICCION_ENTREGA_INSERT_BULK_REQUESTED: 'RESTRICCION_ENTREGA_INSERT_BULK_REQUESTED',
  RESTRICCION_ENTREGA_INSERT_BULK_SUCCEEDED: 'RESTRICCION_ENTREGA_INSERT_BULK_SUCCEEDED',
  RESTRICCION_ENTREGA_INSERT_BULK_FILED: 'RESTRICCION_ENTREGA_INSERT_BULK_FILED',

  RESTRICCION_ENTREGA_DELETE_BULK_REQUESTED: 'RESTRICCION_ENTREGA_DELETE_BULK_REQUESTED',
  RESTRICCION_ENTREGA_DELETE_BULK_SUCCEEDED: 'RESTRICCION_ENTREGA_DELETE_BULK_SUCCEEDED',
  RESTRICCION_ENTREGA_DELETE_BULK_FILED: 'RESTRICCION_ENTREGA_DELETE_BULK_FILED',
}

export const getRestriccionesEntregaAction = (dispatch, filtros = {}) => {
  dispatch({
    type: actions.RESTRICCIONES_ENTREGA_LOAD_REQUESTED,
    payload: filtros,
  })
}

export const getRestriccionEntregaByIdAction = (dispatch, restriccionId) => {
  dispatch({
    type: actions.RESTRICCION_ENTREGA_BYID_LOAD_REQUESTED,
    payload: restriccionId,
  })
}

export const onSubmitInsertRestriccionEntregaFormAction = (dispatch, restriccion) => {
  dispatch({
    type: actions.RESTRICCION_ENTREGA_INSERT_REQUESTED,
    payload: restriccion,
  })
}

export const onSubmitInsertRestriccionEntregaBulkFormAction = (dispatch, restriccionesBulk) => {
  dispatch({
    type: actions.RESTRICCION_ENTREGA_INSERT_BULK_REQUESTED,
    payload: restriccionesBulk,
  })
}

export const onSubmitDeleteRestriccionesEntregaBulkAction = (dispatch, ids) => {
  dispatch({
    type: actions.RESTRICCION_ENTREGA_DELETE_BULK_REQUESTED,
    payload: ids,
  })
}
